import * as Mamba from '@mamba/clients';
export default async function (context) {
    try {
        Mamba.Log.success(context.route.name, context.route, context);
    }
    catch (error) { }
}
